import { useEffect, useState } from "react";
import { ACTIVE_CUSTOMER, NO_LONGER_CUSTOMER } from "@constants";
import { IUserContactPermissions } from "../../interface/IUserDetails";
import { getContactPermissionRoute, UPDATE_CONTACT_PERMISSION_ROUTE } from "@api-routes";
import {
    getResponseToState,
    getStateToPayload,
    IUserPermissionsGroupResponse,
} from "../mappers/getContactPreferencesMapper";
import { useFetch } from "@common/hook/useFetch";

export const useContactPreferences = () => {
    const [userContactPermissions, setUserContactPermissions] = useState<IUserContactPermissions[]>([]);
    const [language, setLanguage] = useState<string>("en"); // english as default value
    const [isCustomer, setIsCustomer] = useState(true);
    const [getContactPreferenceListState, { get }] = useFetch();
    const [updateContactPreferenceListState, { put }] = useFetch();
    const [permissionGroupName, setPermissionGroupName] = useState<string>("");

    const permissionGroup = isCustomer ? ACTIVE_CUSTOMER : NO_LONGER_CUSTOMER;

    const onUserPermissionsResponse = (userPermissionsResponse?: IUserPermissionsGroupResponse) => {
        if (userPermissionsResponse) {
            const userPermissionsMapped = getResponseToState(userPermissionsResponse);
            const lang = userPermissionsResponse.language;

            setPermissionGroupName(userPermissionsResponse.permissionGroupResponse[0].name);

            if (userPermissionsMapped.length > 0) {
                setUserContactPermissions(userPermissionsMapped[0].permissions);
            }

            lang && setLanguage(lang);
        }
    };

    const getContactPreference = () => {
        get<IUserPermissionsGroupResponse>(getContactPermissionRoute(permissionGroup)).then(onUserPermissionsResponse);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(getContactPreference, [isCustomer]);

    const handleChange = (contactPermission: string): void => {
        const newUserContactPermissions = userContactPermissions.map((permission) =>
            permission.permission === contactPermission
                ? { ...permission, isEnabled: !permission.isEnabled }
                : { ...permission }
        );

        setUserContactPermissions(newUserContactPermissions);
    };

    const updateContactPreferences = () => {
        put<IUserPermissionsGroupResponse>(UPDATE_CONTACT_PERMISSION_ROUTE, {
            body: getStateToPayload(permissionGroup, userContactPermissions, language, permissionGroupName),
        }).then(onUserPermissionsResponse);
    };

    return {
        getContactPreference,
        getContactPreferenceListState,
        handleChange,
        isCustomer,
        setIsCustomer,
        updateContactPreferenceListState,
        updateContactPreferences,
        userContactPermissions,
        language,
        setLanguage,
    };
};
